import { skipToken, useQuery } from '@tanstack/react-query';

import { Assets } from '@air/api';
import { type Airror } from '@air/errors';
import { callAirApi } from '@air/utils-api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const ASSET_CUSTOM_FIELD_VALUES_LIST_COMMON_KEY = 'ASSET_CUSTOM_FIELD_VALUES_LIST_COMMON';

export type UseAssetCustomFieldValuesListCommonParams = {
  boardId: string | undefined;
  includeDescendants: boolean;
  customFieldId: string | undefined;
};

export type UseAssetCustomFieldValuesListCommonOptions = {
  enabled: boolean;
};

export type ListCommonCustomFieldValuesResponse = Exclude<
  Awaited<ReturnType<typeof Assets.CustomFields.listCommon>>,
  Airror
>;

export const getAssetCustomFieldValuesListCommonKey = (params: UseAssetCustomFieldValuesListCommonParams) => [
  ASSET_CUSTOM_FIELD_VALUES_LIST_COMMON_KEY,
  params,
];

export const useAssetCustomFieldValuesListCommon = (
  params: UseAssetCustomFieldValuesListCommonParams,
  options: UseAssetCustomFieldValuesListCommonOptions,
) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const { boardId, includeDescendants, customFieldId } = params;
  const { enabled } = options;

  return useQuery({
    queryKey: getAssetCustomFieldValuesListCommonKey(params),
    queryFn:
      enabled && workspaceId && boardId && customFieldId
        ? () =>
            callAirApi<ListCommonCustomFieldValuesResponse>(() =>
              Assets.CustomFields.listCommon({
                workspaceId,
                boardId,
                includeDescendants,
                customFieldId,
              }),
            )
        : skipToken,
  });
};
